module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1",
    attrs: {
      "id": "heard-about-xm"
    }
  }, [_c('h3', {
    staticClass: "mt-4"
  }, [_vm._v("How did you hear about XMission?")]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-top"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('label', {
    staticClass: "mr-sm-2 sr-only",
    attrs: {
      "for": "hdyh-select"
    }
  }, [_vm._v("Preference")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribution),
      expression: "attribution"
    }],
    staticClass: "custom-select mr-sm-2",
    attrs: {
      "id": "hdyh-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.attribution = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.attribution_types), function(attribution_type) {
    return _c('option', {
      key: attribution_type.id,
      domProps: {
        "value": attribution_type.id
      }
    }, [_vm._v(" " + _vm._s(attribution_type.label))])
  }), 0)]), _vm._v(" "), (_vm.isOtherAttribution) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.other_text),
      expression: "other_text"
    }],
    staticClass: "ml-2",
    attrs: {
      "id": "hdyh-other",
      "type": "text",
      "placeholder": "please specify"
    },
    domProps: {
      "value": (_vm.other_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other_text = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNullAttribution) ? _c('button', {
    staticClass: "btn btn-outline-secondary ml-2",
    attrs: {
      "id": "hdyh-skip"
    },
    on: {
      "click": _vm.skipClicked
    }
  }, [_vm._v("skip")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f81818","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/AttributionDropdown.vue
// module id = 1311
// module chunks = 16